<template>
  <div class="cpr_pd_limit">
    <div class="limit_label">点位日限</div>
    <div class="pd_box">
      <div class="pd_item disable">
        <label class="pd_label">流量</label>
        <el-input-number disabled size="mini" placeholder="不限" class="number_input" :controls="false" :min="1"
          :max="9999" :precision="0" :step="1" v-model="flow">
        </el-input-number>
        <i class="unit_append">人次</i>
      </div>
      <div class="pd_item">
        <label class="pd_label">频次</label>
        <el-input-number size="mini" placeholder="请输入" class="number_input" :controls="false" :min="1" :max="999"
          :precision="0" :step="1" v-model="playCount">
        </el-input-number>
        <i class="unit_append">次</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PointLimit',
  props: {
    // 点位流量日限
    limitFlow: Number | undefined,
    // 点位频次日限
    limitPlayCount: Number | undefined
  },
  data() {
    return {}
  },
  computed: {
    flow: {
      get() {
        return this.limitFlow
      },
      set(v) {
        this.$emit('update:limitFlow', v)
      }
    },
    playCount: {
      get() {
        return this.limitPlayCount
      },
      set(v) {
        this.$emit('update:limitPlayCount', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cpr_pd_limit {
  background: #FBFBFB;
  border-radius: 4px;
  border: 1px solid #E9E9E9;
  margin-bottom: 20px;
  .limit_label {
    box-shadow: 0 1px 0 0 #E9E9E9;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
    padding-left: 17px;
  }
  .pd_box {
    padding: 10px;
    .pd_item {
      position: relative;
      display: flex;
      align-items: center;
      background-color: #fff;
      box-shadow: 0 0 0 1px #E9E9E9;
      border-radius: 4px;
      height: 40px;
      padding: 5px 0;
      &.disable {
        background-color: #eee;
        ::v-deep .el-input .el-input__inner {
          background-color: #eee;
        }
      }
      &:not(:last-child) {
        margin-bottom: 10px;
      }
      .pd_label {
        display: inline-block;
        width: 90px;
        box-shadow: 1px 0 0 0 #E9E9E9;
        font-weight: bold;
        margin-right: 10px;
        text-align: center;
      }
      .number_input {
        width: 148px;
        ::v-deep .el-input .el-input__inner {
          border: none;
          padding-left: 0;
          text-align: left;
        }
      }
    }
    .unit_append {
      color: #909399;
      width: 65px;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      text-align: right;
    }
  }
}
</style>
